<div class="container">
  <h1 class="mt-5">Account</h1>
  <p class="lead">Email: {{ authService.getUser()?.email }}</p>

  <button class="btn btn-outline-secondary mt-3" (click)="signOut()">
    Sign Out
  </button>

</div>